export const DARK_THEME_NAME = "dark";
export const LIGHT_THEME_NAME = "light";

export const AVAILABLE_THEMES = [DARK_THEME_NAME, LIGHT_THEME_NAME];

export const DEFAULT_FALLBACK_THEME = DARK_THEME_NAME;

export const DEFAULT_DRAWER_OPEN = false;
